// NPM
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { debounce } from 'lodash';

// Actions, Services, Selectors
import * as actions from 'actions';
import { SEARCH_TAGS } from 'actionTypes';
import {
  getTagSearchResults,
  isActionInProgress,
  selectTopTagEntities,
} from 'selectors';
import { screenService } from 'frontend-component-library';

import { MultiSelect } from 'frontend-component-library';
import TagSearchMenu from './TagSearchMenu';

class TagSearchBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      selectOpened: false,
    };
  }

  handleInputChange = debounce(value => {
    this.setState({ value });
    if (value) {
      this.props.searchTags(value);
    } else {
      this.props.clearTags();
    }
  }, 150);

  handleChange = tags => {
    this.props.setTagFilters(tags);
  };

  getPlaceholderText = () => {
    if (screenService.isLargeDevice()) {
      return 'Search results by location, school, or category';
    } else {
      return 'Search Results';
    }
  };

  render() {
    const {
      isFetching,
      tags,
      tagFilters,
      topCategories,
      topUniversities,
    } = this.props;
    let items;
    if (tags.length) {
      items = tags;
    } else {
      items = topCategories.concat(topUniversities);
    }
    if (!items.length) return null;
    return (
      <div className="TagSearchBar-holder">
        <MultiSelect
          text="Search Tags"
          closedPlaceholder={this.getPlaceholderText()}
          searchPlaceholder={this.getPlaceholderText()}
          onChange={this.handleChange}
          onInputChange={this.handleInputChange}
          options={items}
          value={tagFilters}
          valueKey={null}
          stylingKey="displayClass"
          displayKey="name"
          isLoading={isFetching}
          mobileCloseOnChange={true}
          MenuComponent={TagSearchMenu}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tags: getTagSearchResults(state),
    topCategories: selectTopTagEntities(state, 'categories'),
    topUniversities: selectTopTagEntities(state, 'universities'),
    tagFilters: state.filters.tags,
    isFetching: isActionInProgress(state, SEARCH_TAGS),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setTagFilters: actions.setTagFilters,
      searchTags: actions.searchTags,
      clearTags: actions.clearTags,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TagSearchBar);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/TagSearchBar/TagSearchBar.js